{
  "title": "Contact du conseiller",
  "pageConfigurationInfo": "Les options d'affichage du widget Contact du conseiller (nom, téléphone, courriel, adresse et les boutons bascule associés) sont configurées par page sous",
  "noAccess": "Vous n'avez pas l'autorisation de consulter l'administration des contacts du conseiller.",
  "comingSoon": "Bientôt disponible",
  "none": "— aucun —",
  "noneOption": "— Aucun —",
  "required": "* Obligatoire",
  "tabs": {
    "repCodeManagement": "Gestion des codes de représentant",
    "roleLibrary": "Bibliothèque de rôles",
    "userProfile": "Profil d'utilisateur",
    "advisorContact": "Contact du conseiller",
    "clientView": "Vue client"
  },
  "repCodeManagement": {
    "title": "Gestion des codes de représentant",
    "description": "Le code et le nom sont modifiables ici. Les utilisateurs assignés représentent l'accès, défini sur le profil d'utilisateur de chaque personne. La désignation du contact-conseiller qui représente un code est définie dans l'onglet Contact du conseiller.",
    "designationNote": "La désignation est délimitée à l'enregistrement du contact-conseiller, elle est donc gérée dans l'onglet Contact du conseiller plutôt qu'ici."
  },
  "roleLibrary": {
    "title": "Bibliothèque de rôles du conseiller",
    "description": "L'ordre définit la priorité d'affichage. Créez, renommez, supprimez et réorganisez localement, puis enregistrez pour appliquer. Les enregistrements sans rôle assigné sont toujours triés après tous les rôles ici. Lors de l'héritage de l'organisation parente, la bibliothèque est en lecture seule et cette organisation n'a pas de rôles locaux propres.",
    "addRole": "Ajouter un rôle",
    "newRoleName": "Nouveau rôle",
    "roleName": "Nom du rôle",
    "rankPrefix": "Rang",
    "dragHandle": "Faites glisser pour réorganiser",
    "deleteRole": "Supprimer le rôle",
    "dirtyNote": "Vous avez des modifications non enregistrées",
    "saveFailed": "Impossible d'enregistrer les modifications de la bibliothèque de rôles",
    "nameRequired": "Saisissez un nom de rôle",
    "nameDuplicate": "Un autre rôle utilise déjà ce nom",
    "emptyState": "Aucun rôle pour l'instant. Ajoutez un rôle pour commencer à construire la bibliothèque.",
    "inherited": "Hérité",
    "useParentDisplayRoles": "Hériter des rôles d'affichage de l'organisation parente",
    "inheritModal": {
      "turnOnTitle": "Hériter des rôles de l'organisation parente?",
      "turnOnBody": "Les rôles propres à cette organisation seront archivés et remplacés par la bibliothèque en lecture seule de l'organisation parente. Pendant l'héritage, vous ne pouvez pas ajouter, renommer, réorganiser ou supprimer des rôles.",
      "rolesArchived": "rôle(s) local(aux) sera/seront archivé(s)",
      "contactsReset": "contact(s) du conseiller verra/verront son/leur rôle d'affichage réinitialisé à vide",
      "turnOnNoImpact": "Cette organisation n'a pas de rôles locaux, donc rien ne sera archivé.",
      "turnOffTitle": "Arrêter d'hériter des rôles?",
      "turnOffBody": "La bibliothèque de rôles de cette organisation sera vide jusqu'à ce que vous la reconstruisiez à partir de zéro. Rien n'est copié de l'organisation parente.",
      "turnOffImpact": "Chaque contact-conseiller et utilisateur actuellement assigné à un rôle parent verra son rôle réinitialisé à vide — dans cette organisation et dans chaque organisation enfant qui en hérite.",
      "confirm": "Continuer"
    },
    "deleteModal": {
      "title": "Supprimer ce rôle?",
      "inUse": "La suppression de ce rôle réinitialisera le rôle d'affichage à vide sur chaque contact-conseiller qui l'utilise actuellement lorsque vous enregistrerez. Cette action est irréversible.",
      "notInUse": "Personne n'utilise actuellement ce rôle. Il peut être supprimé en toute sécurité.",
      "advisorContacts": "contact(s) du conseiller",
      "confirm": "Supprimer le rôle"
    },
    "saveModal": {
      "title": "Enregistrer la bibliothèque de rôles?",
      "body": "Les créations, renommages, suppressions et le nouvel ordre d'affichage s'appliqueront immédiatement pour chaque contact-conseiller et widget client qui utilise ces rôles."
    },
    "saveChanges": "Enregistrer",
    "discardChanges": "Abandonner"
  },
  "userProfile": {
    "title": "Profil d'utilisateur",
    "displayRoleComingSoon": "Rôle d'affichage — une étiquette de repli par utilisateur provenant de la Bibliothèque de rôles, affichée uniquement lorsqu'un utilisateur n'est pas le contact-conseiller désigné du compte. Pas encore disponible sur le profil d'utilisateur.",
    "description": "Passez en revue l'identité de l'utilisateur ici, et mettez à jour le rôle d'affichage et les codes de représentant à partir de chaque ligne. Les codes de représentant d'un utilisateur représentent l'accès, et ce sont eux qui servent au calcul des utilisateurs assignés de la Gestion des codes de représentant et de la vérification de la connexion de la Vue client."
  },
  "contacts": {
    "title": "Contact du conseiller",
    "description": "L'identité canonique, visible par le client : nom, téléphone, courriel, adresse et rôle d'affichage. Ajoutez-en un manuellement pour les conseillers sans accès au système, ou liez un profil d'utilisateur — le lien initialise le nom, le téléphone et le courriel une seule fois à partir de cet utilisateur, puis cet enregistrement est modifié indépendamment et ne revient jamais en arrière. Utilisez « Désigné pour » pour choisir le(s) code(s) de représentant que cette identité représente dans la Vue client.",
    "addManual": "Ajouter un contact du conseiller (manuel)",
    "newFirstName": "Nouveau",
    "newLastName": "Conseiller",
    "columns": {
      "name": "Nom",
      "linkedUser": "Utilisateur lié",
      "phone": "Téléphone",
      "email": "Courriel",
      "address": "Adresse",
      "displayRole": "Rôle d'affichage",
      "designatedFor": "Désigné pour"
    },
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "phone": "Téléphone",
    "extension": "Poste",
    "email": "Courriel",
    "address": "Adresse",
    "displayRole": "Rôle d'affichage",
    "designatedFor": "Désigné pour",
    "linkedUserNone": "— Aucun (manuel) —",
    "manualIdentity": "Manuel",
    "inherited": "Hérité",
    "override": "Remplacer",
    "designate": "Désigner…",
    "designateSaveLinkFirst": "Enregistrez le changement d'utilisateur lié avant de modifier les codes de représentant désignés.",
    "undesignate": "Supprimer la désignation",
    "emptyState": "Aucun contact du conseiller pour l'instant. Ajoutez-en un manuellement ou liez un utilisateur existant.",
    "firstNameRequired": "Saisissez un prénom",
    "saveFailed": "Impossible d'enregistrer le contact du conseiller",
    "deleteFailed": "Impossible de supprimer le contact du conseiller",
    "overrideFailed": "Impossible de créer une dérogation locale",
    "useParentAdvisorContacts": "Afficher les contacts du conseiller des organisations parentes",
    "modal": {
      "createTitle": "Ajouter un contact du conseiller",
      "editTitle": "Modifier le contact du conseiller"
    },
    "deleteModal": {
      "title": "Supprimer ce contact du conseiller?",
      "confirm": "Supprimer",
      "body": "Ceci archive {{name}} et libère tous les codes de représentant désignés. Cette action est irréversible."
    },
    "inheritModal": {
      "turnOnTitle": "Afficher les contacts du conseiller parents?",
      "turnOnBody": "Les contacts du conseiller des organisations parentes deviendront visibles pour les clients de cette organisation.",
      "turnOffTitle": "Cesser d'afficher les contacts du conseiller parents?",
      "turnOffBody": "Les contacts du conseiller des organisations parentes ne seront plus visibles pour les clients de cette organisation.",
      "turnOffDescendants": "Les organisations enfants qui héritent de cette organisation sont également affectées.",
      "confirm": "Continuer",
      "turnOffCount": "contact(s) du conseiller hérité(s) sur cette page ne sera/seront plus visible(s) pour les clients."
    },
    "pruneModal": {
      "title": "Certaines désignations seront supprimées",
      "body": "L'utilisateur nouvellement lié ne détient pas ces codes, ils seront donc supprimés :",
      "confirm": "Continuer"
    },
    "emptyStateBrokenFilter": "Aucun conseiller parti ne correspond à ce filtre.",
    "brokenFilter": "Afficher uniquement les conseillers partis",
    "brokenIndicator": "Parti",
    "departedSuffix": "(parti)",
    "brokenDesignationDisabled": "Les désignations ne sont pas disponibles tant que l'utilisateur lié est inactif. Reliez ce contact à un utilisateur actif ou dissociez-le d'abord.",
    "brokenNotice": {
      "title": "L'utilisateur lié n'est plus actif",
      "body": "Cet utilisateur lié est parti ou a été désactivé, ce contact n'est donc plus lié à un utilisateur actif. Reliez-le à un utilisateur actif ci-dessous, ou dissociez-le pour le conserver comme identité manuelle. Ses codes de représentant désignés ont déjà été effacés.",
      "unlink": "Dissocier",
      "unlinkPending": "Ce contact sera dissocié et conservé comme identité manuelle lorsque vous enregistrerez.",
      "unknownUser": "L'utilisateur lié de ce conseiller",
      "inheritedResolve": "L'organisation parente doit résoudre ce conseiller parti."
    },
    "invalidPhone": "Veuillez saisir un numéro de téléphone valide",
    "designateLinkMismatch": "Supprimez les codes de représentant désignés que l'utilisateur lié ne détient pas, puis enregistrez à nouveau.",
    "linkedUserSearchTruncated": "Affichage de {{shown}} correspondances sur {{total}}. Continuez à taper pour affiner.",
    "linkedUserSearchFailed": "Impossible de rechercher des utilisateurs.",
    "linkedUserNoOptions": "Aucun utilisateur ne correspond à cette recherche.",
    "unlinkUser": "Dissocier l'utilisateur",
    "designateHeldBySameUser": "(détenu par {{name}})",
    "designateSameUserConflict": "Cet utilisateur a déjà un autre contact-conseiller désigné pour : {{codes}}. Supprimez d'abord le code à cet endroit.",
    "overriddenLocally": "Remplacé localement"
  },
  "description": "L'accès (accès au code de représentant pour un utilisateur) et la désignation (quel code de représentant un contact-conseiller représente) sont résolus séparément. Utilisez la Vue client pour rechercher un client et prévisualiser les conseillers qu'il verra.",
  "clientView": {
    "title": "Vue client",
    "detailDescription": "Choisissez un compte pour modifier la visibilité, ou un ménage pour prévisualiser la visibilité compilée.",
    "search": "Rechercher des clients",
    "grainLabel": "Portée",
    "grainAccount": "Compte",
    "grainHousehold": "Ménage",
    "selectAccount": "Sélectionner un compte",
    "selectHousehold": "Sélectionner un ménage",
    "selectScope": "Sélectionnez un compte ou un ménage pour prévisualiser les conseillers résolus.",
    "householdReadOnly": "Pour modifier la visibilité, passez à la portée Compte et modifiez par compte.",
    "visibleForAccount": "Visible pour ce compte",
    "visibleForAccountNamed": "Visible pour ce compte : {{name}}",
    "visibleForHousehold": "Visible pour ce ménage",
    "orgWideHide": "Masqué par une règle à l'échelle de l'organisation",
    "scopedOverride": "Ce compte remplace la règle à l'échelle de l'organisation",
    "notEnabled": "La résolution n'est pas activée pour cette entreprise.",
    "toggleFailed": "Impossible de mettre à jour la visibilité",
    "emptyList": "Aucun client ne correspond à cette recherche.",
    "emptyAccounts": "Ce client n'a aucun compte à prévisualiser.",
    "emptyHouseholds": "Ce client ne fait pas partie d'un ménage à prévisualiser.",
    "scopeLoadFailed": "Impossible de charger les comptes ou les ménages pour ce client.",
    "accountsTruncated": "Affichage de {{shown}} comptes sur {{total}}. Les autres ne sont pas dans cette liste.",
    "emptyResolution": "Aucun conseiller ne se résout pour cette portée.",
    "emptyPreview": "Aucun conseiller n'est visible pour ce client pour la portée sélectionnée.",
    "missingPlacement": "Le contact du conseiller ne figure pas dans la configuration de la page {{pageType}}.",
    "usingOptions": "Utilisation des options de la configuration de la page {{pageType}}",
    "pageType": {
      "INDIVIDUAL": "Individuel",
      "NON_INDIVIDUAL": "Non-individuel",
      "HOUSEHOLD": "Ménage"
    },
    "columns": {
      "name": "Nom",
      "email": "Courriel",
      "id": "ID client",
      "phone": "Téléphone",
      "displayRole": "Rôle d'affichage",
      "identity": "Identité",
      "note": "Note",
      "visibleToClient": "Visible pour le client",
      "visibleOn": "Visible sur",
      "visibility": "Visibilité"
    },
    "identity": {
      "curated": "Géré",
      "raw": "Brut"
    },
    "note": {
      "designated": "Contact-conseiller désigné pour le code de représentant {{code}}",
      "repCodeHolder": "Détient le code de représentant {{code}}; aucun contact désigné pour ce code",
      "grantAccess": "A un accès octroyé à ce client",
      "manual": "Contact-conseiller désigné, indépendant de la personne (aucun utilisateur lié)",
      "hidden": "Masqué pour ce client"
    },
    "preview": {
      "title": "Contactez votre conseiller"
    },
    "sections": {
      "scope": "Portée",
      "resolvedAdvisors": "Conseillers résolus"
    },
    "description": "Recherchez un client, puis choisissez un compte ou un ménage pour prévisualiser les conseillers qu'il verra.",
    "searchTruncated": "Affichage de {{shown}} correspondances sur {{total}}. Continuez à taper pour affiner.",
    "searchFailed": "Impossible de rechercher des clients.",
    "selectClient": "Recherchez un client ci-dessus pour prévisualiser la visibilité du conseiller.",
    "selectPageConfiguration": "Sélectionner la configuration de la page",
    "missingPagePlacement": "Le contact du conseiller ne figure pas sur {{pageName}}.",
    "usingPageOptions": "Utilisation des options de {{pageName}}"
  }
}
